import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { CommandName } from 'utils/commands';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { pubSub } from 'utils/pubSub';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButton } from '../topbarButton';

export const KeyboardCheatSheetTopbarButton = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { cmdK } = useFeatureFlag(['cmd-k']);

  const openCheatSheet = useCallback(() => {
    ampli.commandExecuted({
      commandName: 'app:keyboardCheatSheet' satisfies CommandName,
      location: 'topbar',
    });

    pubSub.publish('command:app:keyboardCheatSheet');
  }, []);

  const openCommandPalette = useCallback(() => {
    ampli.commandExecuted({
      commandName: 'app:commandPalette' satisfies CommandName,
      location: 'topbar',
    });

    dispatch(appActions.showModal({ modal: { type: 'app:commandPalette' } }));
  }, [dispatch]);

  // When command palette feature is enabled, show Cmd+K button instead
  if (cmdK) {
    const cmdKTooltip = (
      <CommandKeybindingsTooltipContent commandName="app:commandPalette">
        Command palette
      </CommandKeybindingsTooltipContent>
    );

    return (
      <TopbarButton
        onClick={openCommandPalette}
        icon="bolt"
        tooltip={cmdKTooltip}
        data-cmdk-details-expand-helper
      />
    );
  }

  // Default: keyboard cheat sheet
  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="app:keyboardCheatSheet">
      Keyboard cheat sheet
    </CommandKeybindingsTooltipContent>
  );

  return (
    <TopbarButton onClick={openCheatSheet} icon="keyboard" tooltip={tooltip} />
  );
};
